export default __webpack_public_path__ + "1a4bdc32e2ff9939f4a1796187df0518.png";